/**
 * @desc getReport
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(params: API.walmart.test.getGetReport.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/getReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
